import React, { useContext, useEffect, useState } from 'react';
import { DataGridPremium, GridToolbar, frFR } from "@mui/x-data-grid-premium";
import DocumentTitle from '../../components/DocumentTitle/DocumentTitle';
import { ToWords } from 'to-words';
import Box from "@mui/material/Box";
import { StringToUpperCase, formatStringNumber, objecttoFormData } from '../../services/Helpers/fonctions';
import Erreurs from '../../components/Erreurs/Erreurs';
import { useLocation, useNavigate } from 'react-router-dom';
import Api from '../../services/Api';
import { useRecoilState } from 'recoil';
import { loadingState } from '../../recoil/atoms/loadingAtom';
import moment from 'moment/moment';
import { UserContext } from '../../services/Context/Context';
import ToolbarCMC from '../../components/ToolBarPaiementListCMC/ToolBarPaiementListCMC';
import { useGridApiRef } from '@mui/x-data-grid';
export default function PaiementCMCList() {
    const apiRef = useGridApiRef();
    const navigate = useNavigate();
    const [ filterData,setFilterData ] = useState({
      startDate: '',
      endDate: '',
    });
    const [montantValider,setMontantValider ] = useState(0);
    const[ pageState,setPageState ] = useState({
      data:[],
      total: 0,
      page: 1,
      pageSize: 10 
    });
    const [sortModel, setSortModel] = useState([]);
    const [filterModel, setFilterModel] = useState({ items: [] });
    let { state } = useLocation();
    const [formFilters, setFormFilters] = useState({
      reference: '',
      startDate: '',
      endDate: ''
    });
    const api = new Api();
   
    const toWords = new ToWords({
        localeCode: 'fr-FR',
        converterOptions: {
          currency: false,
          ignoreDecimal: false,
          ignoreZeroCurrency: false,
          doNotAddOnly: false,
        }
      });
    const [erreurs, setErreurs ] = useState([]);  
    const [isLoading,setIsLoading] = useRecoilState(loadingState);

    const handleInput = (e) => {
      if(filterModel?.items?.length > 0 )
         setFilterModel({ items: [] });

        setFilterData({...filterData,[e.target.name]:e.target.value })
    } 
    
    const submitSearch = async (e) => {
      e.preventDefault();
      //console.log(filterData)
      var formdata ;
      var url = `/paiement/cmc/filter?options='default'&pageSize=${pageState.pageSize}&currentPage=${pageState.page}`
      
      if( filterModel?.items?.length > 0 ){
         url = `/paiement/cmc/filter?options='soft_filter'&pageSize=${pageState.pageSize}&currentPage=${pageState.page}`;
         formdata = objecttoFormData(filterData);
         formdata.append('params',JSON.stringify(filterModel?.items));

      }
      else {
       if( typeof filterData.params !== 'undefined'){
          const state = { startDate : filterData.startDate, endDate: filterData.endDate }
          setFilterData(state);
        }
        formdata = objecttoFormData(filterData);
      }
      setErreurs([]);setIsLoading(true);
      const { status,data,errors }  =  await api.apiData("post",url,formdata);
   
      setIsLoading(false);
    
      setPageState((prev) => ({...prev,pagedata:[]}))
     
      if( status === 200 ){
         
           if( data?.data.length > 0 ){
             const _dataValideStatus = data.data.filter((p) => p.status === 'Validé' );
             setMontantValider(_dataValideStatus.length * 100000);
            const arr = data?.data.map((item,index) => {
           
             return {
               ordre: data.from + index,
               id: item.paiement_id,
               categorie: item.nomCategorie,
               reference: item.reference,
               fullName: item.type_client === "Personnel" ? item.prenomClient + " "+ item.nomClient:item.nom_societe,
               chassis: item.chassis,
               email:item.emailClient ?item.emailClient:"Non fournie",
               telephoneClient: item.telephoneClient,
               nom_agence:item.nom_agence,
               localite:item.prefecture,
               prenomnomAgent: item.prenomAgent + " " + item.nomAgent,
               date: moment(item.created_at).format("Do MMMM  YYYY"),
               status:item.status,
               type_client: item.type_client
               
             }
           }); 
        
            setPageState((prev) => ({...prev,data: arr,total:data.total}));
          }
         
      }  
      else setErreurs(errors);
      
    } 
    const columns = [
      {
        field: "ordre",
        headerName: "N°",
        minWidth: 80,
      },
      {
        field: "categorie",
        headerName: "Categorie",
        minWidth: 180
      },
      {
        field: "chassis",
        headerName: "chassis",
        minWidth: 180
      },
      {
        field: "reference",
        headerName: "Référence",
        minWidth: 210
      },
      {
        field: "type_client",
        headerName: "Type Client",
        minWidth: 210
      },
      {
        field: "fullName",
        headerName: "Nom Complet",
        minWidth: 240
      },
      {
        field: "telephoneClient",
        headerName: "Téléphone du Client",
        minWidth: 120
      },
      {
        field: "nom_agence",
        headerName: "Agence",
        minWidth: 150
      },
      {
        field: "prenomnomAgent",
        headerName: "Prenom et Nom Agent",
        minWidth: 150
      },
      {
        field: "localite",
        headerName: "Localité",
        minWidth: 150
      },
     
      {
        field: "status",
        headerName: "status",
        minWidth: 150,
       
        renderCell: (params) => {
          return (
           <div className='status'>
             <div className={`${params.row.status === `Validé`?"valider":params.row.status === `Annulé`?"annuler":"default-status"}`}>{ params.row.status }</div>
          </div>)
        }
      },
      {
        field: "date",
        headerName: "Date de Crt.",
        minWidth: 150,
      
      },
      {
        field: "options",
        headerName: "Options",
        sortable: false,
        flex: 1,
        hide:false,
        filterable: false ,
        sortable:false,
        minWidth: 150,
        renderCell: (params) => {
          const id = params.id;
          return (
            <div className="options">
               <button onClick={() => navigate(`/cmc/details/${id}`)} >Voir facture</button>
            </div>
          );
        },
     }
    ];
    const getPaiements = async () => {
     try{ 
          setErreurs([]);setIsLoading(true);
          const page =  pageState.page + 1; 
          let params = {
          pageSize: pageState.pageSize,
          currentPage: page,
          ...formFilters // Include form filters
          }
          if (filterModel.items.length > 0) {
            filterModel.items.forEach(filter => {
              if (filter.value && filter.value.toString().trim() !== '') {
                params[`filter[${filter.field}]`] = filter.value;
              }
            });
          }  
          if( typeof state?.title !== 'undefined' ){
              if(  state.filter_id == 2 ){
                params["filter[currentYear]"] = moment().format("Y")
              }
          }
        var url = `/paiement/cmc/liste`;
       
        const { status,data,errors } = await api.apiData("get",url,{ params });
        let getData = [];
        //console.log(data)
        if( status === 200 ){
              if( data?.data.length > 0 ){
                getData = data?.data.map((item,index) => {
                return {
                  ordre: data.from + index,
                  id: item.paiement_id,
                  categorie: item.nomCategorie,
                  reference: item.reference,
                  fullName: item.type_client === "Personnel" ? item.prenomClient + " "+ item.nomClient:item.nom_societe,
                  chassis: item.chassis,
                  email:item.emailClient ?item.emailClient:"Non fournie",
                  telephoneClient: item.telephoneClient,
                  nom_agence:item.nom_agence,
                  localite:item.prefecture,
                  prenomnomAgent: item.prenomAgent + " " + item.nomAgent,
                  date: moment(item.created_at).format("Do MMMM  YYYY"),
                  status:item.status,
                  type_client: item.type_client
                  
                }
              }); 
          
              setPageState((prev) => ({...prev,data: getData,total:data.total}));
            }
        
       }  
        else setErreurs(errors);
      }
      catch(e){
         console.log(e);
         setErreurs([{ message: "Failed to load data" }]);
      }
      finally{
        setIsLoading(false)
      }
    }

    const handlePaginationModelChange = (newPaginationModel) => {
      setPageState(prev => ({
        ...prev,
        page: newPaginationModel.page,
        pageSize: newPaginationModel.pageSize
      }));
    };
    // Handle form filter changes
    const handleFormFilterChange = (e) => {
      const { name, value } = e.target;
      setFormFilters(prev => ({
        ...prev,
        [name]: value
      }));
    }; 
    const handleFilterModelChange = (newModel) => {
      setFilterModel(newModel);
      state = undefined;
      setPageState(prev => ({ ...prev, page: 0 }));
    };
    useEffect(() => {
      getPaiements()
     },[pageState.page,pageState.pageSize,filterModel]);
    const handleFormSubmit = (e) => {
      e.preventDefault();
      // Reset to first page when form filters change
      state = undefined;
      setPageState(prev => ({ ...prev, page: 0 }));
      // Trigger data fetch
      getPaiements();
    };

    return (
        <div className='payment-list page'>
            <DocumentTitle title="Liste de paiements des CMC" />
            <div className='header'>
              <h3>Liste de paiements des CMC</h3>
                {typeof pageState.total === 'number' && 
                <p>
                paiements effectués |  
                <span>
                    <strong> Montant Global : </strong>
                    {toWords.convert(pageState.total * 100000) + " Francs Guinéens"} (
                    <strong>{formatStringNumber(pageState.total * 100000)+ " fg"}</strong>)
                </span>
                </p>}
            </div> 
            <div className="filters">
         <form onSubmit={handleFormSubmit}>

          <h4>Filtres</h4>
          <div className="input-group">
            <label>
              Date début
              <input type="date" name="startDate" 
                 id="startDate" 
                 placeholder="Date de début"
                 onChange={handleFormFilterChange}
                 />
            </label>
            <label>
              Date fin
              <input type="date" name="endDate"
                 id="endDate" 
                 placeholder="Date de fin"
                 onChange={handleFormFilterChange}
                 />
            </label>
          </div>
          <Erreurs validation = {erreurs} />
          <button type="submit">Rechercher</button>
        </form>
        </div>  
       
    
        
         <div className="array">
          <Box sx={{ height: "60vh", width: "100%" }}>
            <DataGridPremium
               sx={{ borderRadius: 0 }}
               density="compact"
               columns={columns}
               autoPageSize
               pagination
               disableSelectionOnClick={false}
               localeText={ frFR.components.MuiDataGrid.defaultProps.localeText }
               rows={pageState.data || []}
               rowCount={pageState.total || 0}
               page={pageState.page - 1 }

              slots={{
                toolbar: ToolbarCMC, // Your custom component
               
              }}
              slotProps={{
                toolbar: { // Props for your custom component
                  apiRef, 
                  formFilters,  
                  filterModel,
                  setIsLoading, 
                  isLoading
                },
                
              }}
              onPaginationModelChange={handlePaginationModelChange}
              onFilterModelChange={handleFilterModelChange}
              paginationMode="server"
              filterMode="server"
              onPageSizeChange={(newpageSize, details ) => {
                // Maybe save into state
                setPageState((prev) => ({...prev,pageSize:newpageSize}))
              }}
              onPageChange={(newPage) => {
                setPageState(prev => ({ ...prev, page: newPage + 1 }))
              }}
              apiRef={apiRef}
              
              />
          </Box>
        </div>
    
     </div>
  )
}
